import React from 'react'
import { Form, Formik } from 'formik'

import Input from '../../components/common/Input'
import { required } from '../../utils/validators'
import Button from '../../components/common/Button'
import Select from '../../components/common/Select'
import { payment, paymentTypeOptions } from '../../utils/types'
import { useLoad } from '../../hooks/request'
import { CATEGORY_LIST } from '../../urls'

export default function ExpenseForm({ onCancel, onSubmit, loading, initialValues }) {
    const { response: categoryResponse } = useLoad({ url: CATEGORY_LIST, params: { size: 1000 } })
    const categoryItems = categoryResponse ? categoryResponse.results : []

    return (
        <Formik
            onSubmit={onSubmit}
            initialValues={{
                status: '',
                date: '',
                note: '',
                amount: '',
                category: '',
                subcategory: '',
                paymentType: '', // Default to naqd
                ...initialValues,
            }}
        >
            {({ setFieldValue }) => (
                <Form>
                    <div className="columns">
                        <div className="column">
                            <Select optionValue="value" optionLabel="name" name="status" label="Тип расхода" options={payment} disabled={loading} />
                            <Select
                                validate={required}
                                empty
                                name="category"
                                options={categoryItems.filter((item) => item.parent === null)}
                                onChange={(e) => {
                                    const selectedCategoryId = e.target.value
                                    setFieldValue('category', selectedCategoryId)
                                }}
                                label="Категория"
                                disabled={loading}
                            />
                            <Input name="date" type="date" label="Sana" validate={required} disabled={loading} />
                            <Select optionValue="value" optionLabel="name" name="paymentType" label="То'лов тури" options={paymentTypeOptions} disabled={loading} />

                            <Input name="amount" type="number" step="0.01" label="Цена поступление" validate={required} disabled={loading} />

                            <Input component="textarea" name="comment" label="Примечание" validate={required} disabled={loading} />
                        </div>
                    </div>
                    <div style={{ gap: 5 }} className="buttons is-flex is-justify-content-space-between mt-4">
                        <div className="button-wrapper">
                            <Button onClick={onCancel} icon="close-outline" text="Ёпиш" className="is-danger" />
                        </div>
                        <div className="button-wrapper">
                            <Button loading={loading} text="Сақлаш" icon="add-outline" type="submit" className="is-success" />
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    )
}
